import React from 'react';
import { Nav, Image, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/logo-white-without-text.png';
import { apiFetch } from '../../utils/api'; // ДОБАВИЛИ ИМПОРТ

export function AdminPanel({ show, onToggle }) {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  const handleLogout = async () => {
    if (window.confirm("Выйти из системы?")) {
      await apiFetch('/api/admin/logout', { method: 'POST' });
      localStorage.removeItem('adminToken'); // На всякий случай чистим старый ключ
      window.location.href = '/admin/login';
    }
  };

  const menuItems = [
    { path: '/admin/edit', label: 'Каталог услуг', icon: 'bi-grid' },
    { path: '/admin/categories', label: 'Категории', icon: 'bi-tags' },
    { path: '/admin/showcase', label: 'Услуги на главной', icon: 'bi-star' },
    { path: '/admin/slides', label: 'Главный экран', icon: 'bi-images' },
    { path: '/admin/price', label: 'Прайс-лист', icon: 'bi-currency-dollar' },
    { path: '/admin/stat', label: 'Аналитика', icon: 'bi-graph-up' },
  ];

  return (
    <div className={`admin-sidebar d-flex flex-column bg-dark text-white shadow ${show ? 'show' : ''}`}>
      <div className="p-4 text-center border-bottom border-secondary d-flex justify-content-between align-items-center">
        <div className="flex-grow-1">
          <Image src={logo} width="35" className="mb-1" />
          <div className="fw-bold small text-uppercase tracking-widest">Complex Admin</div>
        </div>
        <Button variant="link" className="text-white d-lg-none p-0" onClick={onToggle}>
          <i className="bi bi-x-lg fs-3"></i>
        </Button>
      </div>
      
      <Nav className="flex-column p-3 gap-2">
        {menuItems.map(item => (
          <Nav.Link 
            as={Link} 
            to={item.path} 
            key={item.path}
            onClick={() => { if(window.innerWidth < 992) onToggle(); }}
            className={`rounded-3 p-3 d-flex align-items-center ${
              isActive(item.path) ? 'bg-primary text-white shadow-sm' : 'text-white-50'
            }`}
          >
            <i className={`bi ${item.icon} me-3 fs-5`}></i>
            <span>{item.label}</span>
          </Nav.Link>
        ))}

        {/* Кнопка выхода */}
        <Nav.Link onClick={handleLogout} className="text-danger small d-flex align-items-center mt-3 border-top border-secondary pt-4 opacity-75">
          <i className="bi bi-box-arrow-right me-3 fs-5"></i>
          <span>Выйти из системы</span>
        </Nav.Link>
      </Nav>

      <div className="mt-auto p-4 border-top border-secondary">
        <Nav.Link as={Link} to="/" className="text-white-50 small d-flex align-items-center">
          <i className="bi bi-arrow-left-circle me-2"></i> Вернуться на сайт
        </Nav.Link>
      </div>
    </div>
  );
}
